export const NonFinancialDataTabs = {
  PersonalDetails: 'personal-details',
  Dependants: 'dependants',
  HealthAndVulnerabilities: 'health-and-vulnerabilities',
  Employment: 'employment',
  Objectives: 'objectives',
  EstatePlanning: 'estate-planning',
  RiskAndInvestmentPreferences: 'risk-and-investment-preferences',
  TaxAndAdviceMoments: 'tax-and-advice-moments',
  AdvisorsProfessionalConnections: 'advisors-professional-connections',
  SavedMemories: 'saved-memories',
} as const;
